import { AxiosResponse } from "axios";
import httpClient from "../../api/httpClient";
import { DashAcompParceiros } from "../classes/DashAcompParceiros";

interface HttpCalls {
  method: string;
  rota: string;
}

const calls: HttpCalls[] = [
  { method: "GET", rota: "DashboardAcompanhamentoParceiros" },
];
const apiServico: string = "DASHBOARD";

export default class DashParceiroDataset extends httpClient {
  constructor() {
    super(apiServico);
  }

  async getAll(
    contratoSap: string[],
    sku: string[],
    dataInicio: Date,
    dataFim: Date,
    parceiros: number[]
  ): Promise<DashAcompParceiros> {
    let ok: boolean = false;
    let data: DashAcompParceiros;
    let error: any = undefined;

    let params = `dataInicial=${dataInicio.toDateString()}&dataFinal=${dataFim.toDateString()}`;

    parceiros.forEach(x=> params += `&codigoFornecedorSap=${x}`);
      sku.forEach(x=> params += `&sku=${x}`);
      contratoSap.forEach(x=> params += `&numerocontrato=${x}`);

    await super
      .Get(`${calls[0].rota}?${params}`)
      .then((response: AxiosResponse) => {
        ok = response.status === 200;
        data = response.data
      })
      .catch((erro) => {
        ok = false;
        error = erro;
      });
    if (error !== undefined && ok === false) throw error;
    return new Promise<DashAcompParceiros>((resolve) => {
      resolve(data);
    });
  }
}
